import React from "react"
import { Helmet } from "react-helmet"
import { Card, CardBody, Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function BlogsList() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/news&blogs/list",
    },
    paths: [
      {
        label: "News & Blogs",
        link: "/news&blogs/list",
      },
    ],
  }
  return (
    <React.Fragment>
      <Helmet>
        <title>News & Blogs List | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />
          <Card>
            <CardBody>
              <List />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BlogsList
